import AdminOnly from 'layout/AdminOnly';
import ClusteredBarChart from '../charts/clusteredBarChart';
import DashboardApi from 'api/dashboard';
import DataTable from '../dataTable';
import find from 'lodash/find';
import Loader from '../loader.jsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {calcuatePercenatgeDifference, getDateLabel} from 'helpers/dashboardFormatter';
import {capitalizeFirstLetters} from 'helpers/stringHelper';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';
import events from 'lib/events';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

function updatePeriodForTimeframe(timeframe, record) {
  if (timeframe === 'week') {
    record.period = moment().day(record.periodNumber).format('ddd');
  }

  if (timeframe === 'year') {
    record.period = moment().month(record.periodNumber - 1).format('MMM');
  }

  return record;
}

class TotalWaterAnalysis extends Component {
  static propTypes = {
    start: PropTypes.any,
    end: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.array,
    timeframe: PropTypes.string.isRequired,
    branchesFull: PropTypes.any,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    timeframe: 'month',
  };

  constructor(props) {
    super(props);
    this.state = {
      report: null,
      loaded: false,
      table: null,
    };
  }

  componentDidMount() {
    this.onUpdate();

    this.localeBind = events.subscribe('locale.changed', this.onUpdate);
  }

  componentDidUpdate(prevProps) {
    const {timeframe, branch} = this.props;

    if (prevProps.timeframe !== timeframe || prevProps.branch !== branch) {
      this.onUpdate();
    }
  }

  componentWillUnmount() {
    this.setState({
      report: null,
      table: null,
      loaded: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    if (this.localeBind && this.localeBind.remove) {
      this.localeBind.remove();
    }
  }

  onUpdate = () => {
    const {start, branch, branches, timeframe} = this.props;
    let end = moment();
    let weeks = moment().weeks();
    let month = moment().month();
    let start2 = moment().subtract(1, 'year');
    let end2 = moment().subtract(1, 'year');

    if (timeframe === 'week') {
      end = end.endOf('isoweek');
      start2 = start2.weeks(weeks).startOf('isoweek');
      end2 = end2.weeks(weeks).endOf('isoweek');
    } else if (timeframe === 'month') {
      end = end.endOf('month');
      start2 = start2.month(month).startOf('month');
      end2 = end2.month(month).endOf('month');
    } else if (timeframe === 'year') {
      end = end.endOf('year');
      start2 = start2.startOf('year');
      end2 = end2.endOf('year');
    }
    this.setState({
      report: null,
      table: null,
      loaded: false,
    });


    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.totalWaterAnalysis(branch === -1 ? branches : branch,
      start, end, start2, end2, timeframe)))
      .then(data => {
        this.setState({
          report: data.byPeriod.map(updatePeriodForTimeframe.bind(null, timeframe)),
          table: data.byBranch,
          loaded: true,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          loaded: false,
        });
      });
  };

  getDataRows() {
    const {table} = this.state;
    const {branchesFull} = this.props;

    if (!table || !branchesFull) {
      return null;
    }
    let thisYearTotal = 0;
    let lastYearTotal = 0;

    const data = table.map(t => {
      thisYearTotal += t.thisYearCount;
      lastYearTotal += t.lastYearCount;
      const branchName = branchesFull.find(x => x.id === t.branch);

      return [
        <div key='branch' className='tc'>
          {branchName.name + ' ' + capitalizeFirstLetters(this.props.intl.formatMessage({id: 'posdashboard.water.analyses'}))}
        </div>,
        <div key='count.last-year' className='tc'>{t.lastYearCount}</div>,
        <div key='count.this-year' className='tc'>{t.thisYearCount}</div>,
        <div key='count.percent' className='tc'>{calcuatePercenatgeDifference(t.lastYearCount, t.thisYearCount, true)}</div>,
      ];
    });
    //add bottom row

    data.push([
      <div key='ph1' className='tc'/>,
      <div key='ph2' className='tc'/>,
      <div key='ph3' className='tc'/>,
      <div key='ph4' className='tc'/>,
    ]);
    data.push([
      <div key='total' className='tc'>TOTAL</div>,
      <div key='total.last-year' className='tc'>{lastYearTotal}</div>,
      <div key='total.this-year' className='tc'>{thisYearTotal}</div>,
      <div key='total.percent' className='tc'>{calcuatePercenatgeDifference(lastYearTotal, thisYearTotal, true)}</div>,
    ]);

    return data;
  }

  getHeaderRow() {
    const {table} = this.state;
    const {timeframe} = this.props;

    if (!table) {
      return null;
    }

    return [
      <div className='tc'
           key='header.store'><FormattedMessage id="general.store"/></div>,
      <div className='tc'
           key='header.date1'><i className='color-box dark-blue-box'/>
        {getDateLabel(timeframe, true)}
      </div>,
      <div className='tc'
           key='header.date2'><i className='color-box light-blue-box'/>
        {getDateLabel(timeframe, false)}
      </div>,
      <div className='tc'
           key='header.change'>% <FormattedMessage id="general.change"/></div>,
    ];
  }

  render() {
    const {report, loaded} = this.state;
    let {formatMessage} = this.props.intl;

    return (
      <div className='total-water-analysis expanded-tile'>
        <Loader loaded={loaded}>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='report-header'>
                <AdminOnly>
                  <a className='dashboard-report-view-link pull-right'
                     href='#reports/water/total-water-analyses'>
                    <span className='underline'><FormattedMessage id="general.view.report"/></span>
                    <i className='bl bl-right_arrow'/></a>
                </AdminOnly>
                <h2 className='title'><FormattedMessage id="general.total.water.analyses"/></h2>
                <hr/>
              </div>
            </div>
          </div>
          {report && report.length > 0 ?
            <div>
              <div className='row'>
                <div className='col-sm-12'>
                  <div className="report-graph">
                    <ClusteredBarChart data={report}
                                       verticalAxisTitle={formatMessage({id: 'posdashboard.number.water.analyses'})}
                                       colors={['#6886ab', '#86cef0']}
                                       titleField='period'
                                       valueFields={['lastYearCount', 'thisYearCount']}
                                       balloonTexts={[formatMessage({id: 'posdashboard.tests.previous.year'}) + ': <b>[[value]]</b>',
                                         formatMessage({id: 'posdashboard.tests.current.year'}) + ': <b>[[value]]</b>']}
                                       fixedColumnWidth={25}
                                       fillAlphas={0.75}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <div className='table-water-total table-biolab table-dashboard'>
                    <DataTable headerRow={this.getHeaderRow()}
                               data={this.getDataRows()}/>
                  </div>
                </div>
              </div>
            </div> :
            <div><FormattedMessage id="posdashboard.error.no.data"/></div>
          }
        </Loader>
      </div>
    );
  }
}

export default injectIntl(bindLocaleUpdate(TotalWaterAnalysis));
